import { getWidgetRegistry } from './widgetRegistry';

export function buildDefaultLayout (t: (key: string) => string) {
  const widgets = getWidgetRegistry(t);
  const children = widgets.filter(entry => entry.includeInDefault).map(entry => entry.defaultLayout);
  return [
    { type: 'grid', container: true, spacing: 3, children }
  ];
}
